module.exports = __webpack_public_path__ + "static/media/DredgingIcon.77829c19.png";